/** 俯瞰カメラ（docs/05_rendering-and-audio.md 10 章）。左ドラッグで平行移動、右ドラッグで回転、ホイールでズーム */
import * as THREE from 'three';
import { MapControls } from 'three/addons/controls/MapControls.js';

export interface OverviewCamera {
  controls: MapControls;
  /** 地点 (x, z) を画面の中心に */
  focus(x: number, z: number): void;
  update(): void;
}

export function createOverviewCamera(
  camera: THREE.PerspectiveCamera,
  dom: HTMLElement,
  bounds: { widthM: number; depthM: number },
  groundY: (x: number, z: number) => number,
): OverviewCamera {
  const controls = new MapControls(camera, dom);
  controls.enableDamping = true;
  controls.dampingFactor = 0.12;
  controls.screenSpacePanning = false;
  controls.zoomToCursor = true;
  controls.minDistance = 1500;
  controls.maxDistance = 140_000;
  controls.maxPolarAngle = THREE.MathUtils.degToRad(78);

  const focus = (x: number, z: number): void => {
    const offset = camera.position.clone().sub(controls.target);
    controls.target.set(x, groundY(x, z), z);
    camera.position.copy(controls.target).add(offset);
  };

  // 初期位置：南側の上空から北を見下ろす
  controls.target.set(0, 1000, 0);
  camera.position.set(0, 26_000, 24_000);
  controls.update();

  return {
    controls,
    focus,
    update() {
      // 注視点はワールドの範囲内に保つ
      const t = controls.target;
      const cx = THREE.MathUtils.clamp(t.x, 0, bounds.widthM);
      const cz = THREE.MathUtils.clamp(t.z, 0, bounds.depthM);
      if (cx !== t.x || cz !== t.z) {
        camera.position.x += cx - t.x;
        camera.position.z += cz - t.z;
        t.x = cx;
        t.z = cz;
      }
      controls.update();
    },
  };
}
